import React from "react";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

export default function DHIconDown({fontSize, style}) {

    return <ArrowCircleDownIcon sx={{ fontSize: fontSize }} style={{...style}}/>
}